import React from 'react'
import SideNav from '../../layouts/side-nav.js'

import './style/index.css'

const components = ['services', 'vendor', 'brokering', 'consulting']

export default () => (
  <div className='services'>
    <div className='services-hero'>
      <div className='services-hero-img' />
    </div>
    <div className='services-title'>
      Services
    </div>
    <div className='services-content'>
      <SideNav components={components} base='services' current='services' />
      <div className='services-intro'>
        We take pride in offering our clients great customer service. We tailor every equipment leasing and financing solution specifically for each individual customer. Whether you are a <strong>lessee</strong> looking for the best way to fund an equipment acquisition, a <strong>vendor</strong> looking to add value to your equipment offering, or a <strong>leasing company</strong>, <strong>lease or finance broker</strong> looking to solve a seemingly impossible problem, we want to help. Put our vast experience in the equipment leasing industry to work for you.
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/services/index.js